module.exports = __webpack_public_path__ + "img/BlinkArt_Axe2H_Epic.0ccf5b2d.png";